'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RiskByYearService = function () {
  function RiskByYearService($http) {
    'ngInject';

    _classCallCheck(this, RiskByYearService);

    Object.assign(this, {
      $http: $http
    });
  }

  _createClass(RiskByYearService, [{
    key: 'getReport',
    value: function getReport(params) {
      return this.$http.get('/api/report/data_a_y_risk', {
        params: _extends({}, params)
      }).then(function (r) {
        return r.data;
      });
    }
  }]);

  return RiskByYearService;
}();

exports.default = RiskByYearService;


// WEBPACK FOOTER //
// ./components/app/reports/risk-by-year/risk-by-year.service.js